/* ============================================================
   Sam's Store — Scroll-Triggered Entrance Animations (Phase 9)
   Uses IntersectionObserver. Zero dependencies, zero libraries.
   Respects prefers-reduced-motion.
   Works on EVERY page — homepage, collections, product, blog.
   ============================================================ */
(function () {
  'use strict';

  /* Skip entirely if user prefers reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Skip if IntersectionObserver not supported (very old browsers) */
  if (!('IntersectionObserver' in window)) return;

  function isAlreadyVisible(el) {
    var rect = el.getBoundingClientRect();
    /* Element is already fully or partially in the viewport */
    return rect.top < window.innerHeight - 20 && rect.bottom > 0;
  }

  function setupAnimations() {
    /* ── 1. Animate whole sections ── */
    /* Target all shopify sections — skip header group and anything already visible */
    var allSections = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-header):not([class*="header"])'
    );

    allSections.forEach(function (section) {
      /* Skip if already in view (hero, above-fold content) */
      if (isAlreadyVisible(section)) return;

      /* Skip header-type sections */
      if (section.querySelector('.section-header, sticky-header, header-drawer')) return;

      section.classList.add('sam-reveal');

      /* ── 2. Stagger known card children inside the section ── */
      var childSelectors = [
        '.sam-cat__card',        /* Category grid cards */
        '.sam-fp__card',         /* Featured product cards */
        '.card-wrapper',         /* Dawn native product cards */
        '.collection-card-wrapper', /* Dawn collection cards */
        '.multicolumn-card',     /* Multicolumn section items */
        '.blog-article-card',    /* Blog cards */
        '.sam-countdown__unit',  /* Countdown number tiles */
      ].join(',');

      var children = section.querySelectorAll(childSelectors);
      children.forEach(function (child) {
        child.classList.add('sam-reveal-child');
      });

      /* ── 3. Animate section headings slightly before children ── */
      var headings = section.querySelectorAll(
        '.sam-fp__title, .sam-cat-grid__heading, h2.title, .title'
      );
      headings.forEach(function (h) {
        /* Only if not already a reveal-child */
        if (!h.classList.contains('sam-reveal-child')) {
          h.classList.add('sam-reveal-heading');
        }
      });
    });

    /* ── Create the IntersectionObserver ── */
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sam-reveal--visible');
            /* Unobserve after animating — runs once only */
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.07,
        rootMargin: '0px 0px -50px 0px' /* Trigger slightly before fully in view */
      }
    );

    /* Observe all sections marked for reveal */
    document.querySelectorAll('.sam-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAnimations);
  } else {
    setupAnimations();
  }
})();
